var sko = require('./safekeyobject.es6').default;

window.emoji = {};
// settings
emoji.img_path = 'emoji/';
emoji.img_suffix = '';
emoji.colon_aliases = {};
emoji.text_maps = new sko();
emoji.unified_blacklist = {};
emoji.non_native = {};

emoji.use_css_imgs = false;
emoji.colons_mode = false;
emoji.text_mode = false;
emoji.include_title = false;
emoji.allow_native = true;
emoji.use_sheet = false;
emoji.with_emocodes = true;

emoji.inits = {};
emoji.map = {};
emoji.categories = [
    "Smileys & Emotion",
    "People & Body",
    "Animals & Nature",
    "Food & Drink",
    "Travel & Places",
    "Activities",
    "Objects",
    "Symbols",
    "Flags"
];

emoji.re = {
    colons: /(:[^\s:]+:)(:skin-tone-[2-6]:)?/,
    strip_colons: /^:(:?[^:]+)(::skin-tone-[2-6])?:$/i,
    strip_colons_only: /^:(.+):$/i,
    multi_skin: /(\w+)-(\w+)/,
    ipv6_hex: /^[a-f0-9]+$/,
    ipv6_mask_pre: /([:*?]|(\b[a-f0-9:*?]+))$/,
    ipv6_mask_post: /^([:*?]|([a-f0-9:*?]+\b))/,
    ua_cr_os: /CrOS/i,
    ua_mac_os: /Mac OS X 1[01][_.][0-9]/i,
    ua_windows_os: /Windows NT 10\.\d/i,
};

emoji.strip_colons = function (colon){
    return colon.replace(emoji.re.strip_colons, "$1");
};
emoji.strip_colons_only = function (colon){
    return colon.replace(emoji.re.strip_colons_only, "$1");
};
emoji.replace_colons = function(str, force_unified, skin_tone, options) {
    options = options || {};
    emoji.init_colons();
    var match = str.match(emoji.re.colons);
    if (!match) {
        return str;
    }
    var matchPart = match[0];
    var colon = match[1];
    var skin_colon = match[2];
    var idx = emoji.strip_colons(colon);
    // We use sko to prevent these issues, but might as well
    // just reject already at this stage
    if (idx == '__proto__') {
        return str;
    }
    var first = str.slice(0, match.index);
    var rest = str.slice(match.index+matchPart.length);
    var val = emoji.map.colons.get(idx);
    if (skin_colon) {
        var skin_idx = emoji.strip_colons(skin_colon);
        var skin_val = emoji.map.colons.get(skin_idx);
        if (skin_val) {
            skin_tone = emoji.data[skin_val][0][0];
        }
    }
    var replaced = ':' + idx;
    var colon_rest = ':' + rest;
    var was_replaced = false;

    if (
        // Filter out ipv6 hex masks
        // 1000:1000:100:1000:0
        // *:100:1000:0
        // ?:100:1000:0
        emoji.re.ipv6_hex.test(idx) && (
            (
                first &&
                first != ':' &&
                !/\s$/.test(first) && (
                    emoji.re.ipv6_mask_pre.test(first) ||
                    emoji.re.ipv6_mask_post.test(rest)
                )
            ) || (
                options.prev && (
                    emoji.re.ipv6_mask_pre.test(options.prev)
                )
            )
        )
    ) {
        rest = colon_rest;
    } else if (
        // Filter out Perl modules
        // Dpkg::package::package::package::package
        (!options.prev_replaced && /:$/.test(first))
    ) {
        rest = colon_rest;
    } else {
        if (val) {
            var titleText = idx;
            if (emoji.colon_aliases[val]) {
                var aliasIdx = _.indexOf(emoji.colon_aliases[val], idx);
                if (aliasIdx !== -1) {
                    var smileyAliasIdx = _.indexOf(emoji.colon_aliases[val], ':' + idx);
                    if (smileyAliasIdx !== -1) {
                        aliasIdx = smileyAliasIdx;
                    }
                    titleText = emoji.colon_aliases[val][aliasIdx];
                }
            }
            replaced = emoji.replacement(val, colon, titleText, colon, force_unified, skin_tone);
            was_replaced = true;
        } else if (emoji.text_maps.has(idx)) {
            replaced = emoji.text_maps.get(idx);
        } else {
            rest = colon_rest;
        }
    }
    return first + replaced + emoji.replace_colons(rest, force_unified, undefined, {
        prev_replaced: was_replaced,
        prev: (options.prev || '') + first + replaced
    });
};
emoji.idx_to_title = function (idx) {
    if (emoji.data[idx]) return emoji.data[idx][3][0];
};
emoji.match_unified = function (str) {
    emoji.init_unified();
    return str.match(emoji.rx_unified);
};
emoji.unified_to_text = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.data[val][3][0];
            var skin_idx = emoji.skin_tone_to_idx(match[2]);
            if (skin_idx) {
                replaced += '::' + emoji.data[skin_idx][3][0];
            }
        } else if (val_var) {
            replaced = emoji.data[val_var[0]][3][0];
            replaced += '::' + emoji.data[val_var[1]][3][0];
        }
        return first + replaced + emoji.unified_to_text(rest);
    } else {
        return str;
    }
};
emoji.strip_unified = function (str, single) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var rest = match[3] + str.slice(match.index+match[0].length);
        if (single) {
            return first + rest;
        } else {
            return first + emoji.strip_unified(rest);
        }
    } else {
        return str;
    }
};
emoji.replace_unified = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.replacement(val, m, emoji.idx_to_title(val), undefined, undefined, match[2]);
        } else if (val_var) {
            var skin_tone_idx = val_var[1];
            var skin_tone_data = emoji.data[skin_tone_idx];
            var skin_tone;
            if (skin_tone_data) {
                skin_tone = skin_tone_data[0][0];
            }
            replaced = emoji.replacement(val_var[0], m, emoji.idx_to_title(val_var[0]), undefined, undefined, skin_tone, skin_tone_idx);
        }
        return first + replaced + emoji.replace_unified(rest);
    } else {
        return str;
    }
};
emoji.make_attrs = function (attrs, extraClass) {
    if (attrs.classNames) {
        attrs.classNames = attrs.classNames.concat(extraClass);
        if (attrs.classNames.length) {
            attrs['class'] = attrs.classNames.join(' ');
        }
        delete attrs.classNames;
    }
    var parts = [];
    for (var attr in attrs) {
        if (attrs[attr] != null) {
            parts.push(attr + '="' + attrs[attr] + '"');
        }
    }
    return parts.length ? ' ' + parts.join(' ') : '';
};
emoji.wrap_span = function (val, attrs, extraClass) {
    extraClass = extraClass || [];
    return '<span'+emoji.make_attrs(attrs, extraClass)+'>' + val + '</span>';
};

emoji.skin_tone_to_idx = function (skin_tone) {
    return emoji.map.skin_tone_to_idx[skin_tone];
};
emoji.idx_to_colon = function (idx, skin_tone) {
    var out = ':'+emoji.data[idx][3][0]+':';
    var skin_idx = emoji.skin_tone_to_idx(skin_tone);
    if (skin_idx) {
        if (emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx]) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
    }
    return out;
};

function get_version (idx) {
    return emoji.data[idx][6];
}
function get_variation_version (idx, skin_idx) {
    if (!skin_idx || !emoji.variations_data[idx]) {
        return get_version(idx);
    }
    return emoji.variations_data[idx][skin_idx][4];
}

// Support probe

var probe_config = {
    fonts: '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Twemoji Mozilla",sans-serif',
    assume_native_up_to: 4.0,
    unknown_is_native: false,
    sentinels: [
        [11.0, '1f970'], // smiling_face_with_3_hearts
        [12.0, '1f971'], // yawning_face
        [12.1, '1f9d1-200d-1f373'], // cook
        [13.0, '1f972'], // smiling_face_with_tear
        [13.1, '1f62e-200d-1f4a8'], // face_exhaling
        [14.0, '1fae0'], // face-smiling
        [15.0, '1fae8'], // shaking_face
        [15.1, '1f34b-200d-1f7e9'], // lime
        [16.0, '1fae9'], // face_with_bags_under_eyes
        [17.0, '1faea'], // distorted_face
    ],
    categories: {
        'country-flag': '1f1fa-1f1f8', // flag-us
        'subdivision-flag': '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f' // flag-england
    },
    special: {
        '1f1fa-1f1f3': true, // flag-un
        '2695-fe0f': true, // medical_symbol
        '2640-fe0f': true, // female_sign
        '2642-fe0f': true, // male_sign
    },
    cache: {},
    ctx: null,
};
emoji.probe_config = probe_config;

function get_probe_ctx () {
    if (!probe_config.ctx) {
        var canvas = document.createElement('canvas');
        canvas.width = 64;
        canvas.height = 48;
        probe_config.ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (probe_config.ctx) {
            probe_config.ctx.textBaseline = 'top';
            probe_config.ctx.font = '28px ' + probe_config.fonts;
        }
    }
    return probe_config.ctx;
}

function run_probe (idx) {
    var ctx = get_probe_ctx();
    if (!ctx) {
        return false;
    }
    try {
        // Unsupported sequences (ZWJ, skin tones, flags) fall back to several
        // separate glyphs, which are much wider than one properly shaped glyph.
        var str = emoji.data[idx][0][0];
        var core = Array.from(str.replace(/\uFE0F/g, ''));
        if (core.length > 1) {
            var base = str.indexOf('\u200D') !== -1 ? str.split('\u200D')[0] : core[0];
            if (ctx.measureText(str).width > ctx.measureText(base).width * 1.5) {
                return false;
            }
        }

        // Tofu and monochrome fallbacks are drawn in the fill color (pure red).
        // A real color glyph contains clearly non-red opaque pixels.
        ctx.clearRect(0, 0, 64, 48);
        ctx.fillStyle = '#f00';
        ctx.fillText(str, 0, 0);
        var d = ctx.getImageData(0, 0, 64, 48).data;
        for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] > 200 && (d[i + 1] > 60 || d[i + 2] > 60)) {
                return true;
            }
        }
    } catch (e) { /* canvas blocked or unreadable */ }
    return false;
}

// Sync, cached. Public so you can also probe an exact emoji yourself.
function probe_supported (idx) {
    if (!idx) {
        return false;
    }
    if (!Object.prototype.hasOwnProperty.call(probe_config.cache, idx)) {
        probe_config.cache[idx] = run_probe(idx);
    }
    return probe_config.cache[idx];
};

function version_native (version) {
    var n = parseFloat(version);
    if (isNaN(n)) {
        return probe_config.unknown_is_native;
    }
    if (n <= probe_config.assume_native_up_to) {
        return true;
    }
    var i;
    // An unsupported sentinel at or below this version means this one fails too.
    for (i = 0; i < probe_config.sentinels.length; i++) {
        if (probe_config.sentinels[i][0] <= n && !probe_supported(probe_config.sentinels[i][1])) {
            return false;
        }
    }
    // A supported sentinel at or above this version means this one works too.
    for (i = 0; i < probe_config.sentinels.length; i++) {
        if (probe_config.sentinels[i][0] >= n && probe_supported(probe_config.sentinels[i][1])) {
            return true;
        }
    }
    return probe_config.unknown_is_native;
}

emoji.check_allow_native = function (idx, skin_idx) {
    if (emoji.non_native[idx]) {
        return false;
    }
    if (!(emoji.allow_native && emoji.replace_mode == 'unified' && emoji.data[idx][0][0])) {
        return false;
    }

    // Special cases: probed directly, no version or category gating.
    if (probe_config.special[idx] && !skin_idx) {
        return probe_supported(idx);
    }

    var version = get_variation_version(idx, skin_idx);
    if (!version_native(version)) {
        return false;
    }

    var cat_sentinel = probe_config.categories[emoji.data[idx][7]];
    if (cat_sentinel && !probe_supported(cat_sentinel)) {
        return false;
    }
    return true;
};

emoji.replacement = function(idx, actual, titleText, colon, force_unified, skin_tone, skin_idx) {
    skin_tone = skin_tone || '';
    skin_idx = skin_idx || emoji.skin_tone_to_idx(skin_tone);
    var full_idx = idx;
    var variation_data;
    if (skin_idx) {
        variation_data = emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx];
        if (variation_data) {
            full_idx = variation_data[0];
        } else {
            skin_idx = '';
            skin_tone = '';
        }
    }

    if (force_unified) {
        if (variation_data) {
            return variation_data[3][0];
        } else {
            return emoji.data[idx][0][0] + skin_tone;
        }
    }
    if (emoji.colons_mode) {
        var out = ':'+emoji.data[idx][3][0]+':';
        if (skin_idx) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
        return out;
    }
    if (emoji.text_mode) {
        var text_name = ':' + titleText + ':';
        return text_name;
    }
    emoji.init_env();
    var attrs = {classNames: []};
    if (emoji.include_title) {
        attrs.title = titleText;
    }
    var extraClass = [];
    var emoCode = '';
    if (emoji.with_emocodes && colon) {
        emoCode = emoji.wrap_span(colon, {
            classNames: ['emocode']
        });
        extraClass.push('emoconverted');
    }

    if (emoji.check_allow_native(idx, skin_idx)) {
        extraClass.push('emojinative');
        if (emoji.is_windows_native()) {
            extraClass.push('emojinative--win');
        }
        if (emoji.is_cr_os_native()) {
            extraClass.push('emojinative--cros');
        }
        if (emoji.is_mac_os_native()) {
            extraClass.push('emojinative--mac');
        }
        var native;
        if (variation_data) {
            native = variation_data[3][0];
        } else {
            native = emoji.data[idx][0][0] + skin_tone;
        }

        return emoji.wrap_span(native, attrs, extraClass) + emoCode;
    }
    attrs.classNames.push('emoji');
    var img = emoji.img_path+idx+'.png' + emoji.img_suffix;
    if (emoji.supports_css) {
        var px = emoji.data[idx][4];
        var py = emoji.data[idx][5];
        if (variation_data) {
            px = variation_data[1];
            py = variation_data[2];
            img = emoji.img_path+full_idx+'.png' + emoji.img_suffix;
        }
        if (emoji.use_sheet && px != null && py != null) {
            var mul = 100 / (emoji.sheet_size - 1);
            attrs.style = 'background-position:'+(mul*px)+'% '+(mul*py)+'%;';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else if (emoji.use_css_imgs){
            attrs.classNames.push('emoji-'+full_idx);
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else {
            attrs.classNames.push('emoji-sizer');
            attrs.style = 'background-image:url('+img+')';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        }
    }
    attrs.src = img;
    return '<img' + emoji.make_attrs(attrs) + '>' + emoCode;
};
emoji.init_colons = function(){
    if (emoji.inits.colons) return;
    emoji.inits.colons = 1;
    emoji.map.colons = new sko();
    var names;
    for (var i in emoji.data){
        names = emoji.data[i][3];
        if (emoji.colon_aliases[i]) {
            names = names.concat(emoji.colon_aliases[i]);
        }
        for (var j=0; j<names.length; j++){
            emoji.map.colons.set(names[j].toLowerCase(), i);
        }
    }
};
emoji.init_unified = function(){
    if (emoji.inits.unified) return;
    emoji.inits.unified = 1;

    var a = [];
    emoji.map.unified = {};
    emoji.map.unified_vars = {};
    emoji.map.category = {};
    emoji.map.skin_tone_to_idx = {};

    for (var i in emoji.data){
        if (!emoji.map.category[emoji.data[i][1]]) {
            emoji.map.category[emoji.data[i][1]] = [];
        }
        emoji.map.category[emoji.data[i][1]].push({key: i, item: emoji.data[i]});
        if (emoji.data[i][1] === 'Component' && emoji.data[i][7] === 'skin-tone') {
            emoji.map.skin_tone_to_idx[emoji.data[i][0][0]] = i;
        }

        var eCodes = emoji.data[i][0];
        for (var j = 0; j < eCodes.length; j++) {
            if (!emoji.unified_blacklist[eCodes[j]]) {
                a.push(eCodes[j].replace('*', '\\*'));
                emoji.map.unified[eCodes[j]] = i;
            }
        }
    }
    for (var vi in emoji.variations_data){
        var toAdd = [];
        var eVars = emoji.variations_data[vi];
        for (var vk in eVars) {
            var vCodes = eVars[vk][3];
            var multi_tone = vk.match(emoji.re.multi_skin);
            if (multi_tone && multi_tone[1] == multi_tone[2] && !emoji.variations_data[multi_tone[1]]) {
                toAdd.push([multi_tone[1], eVars[vk]]);
            }
            for (var vj = 0; vj < vCodes.length; vj++) {
                a.push(vCodes[vj].replace('*', '\\*'));
                emoji.map.unified_vars[vCodes[vj]] = [vi, vk];
            }
        }
        // Add simple form same skin tone variations when missing (e.g. people_holding_hands)
        if (toAdd.length) {
            for (var addI = 0; addI < toAdd.length; addI++) {
                eVars[toAdd[addI][0]] = toAdd[addI][1];
            }
        }
    }

    for (var cat in emoji.map.category) {
        emoji.map.category[cat].sort(function (a, b) {
            return a.item[2] - b.item[2];
        });
    }

    // Sort by length so that combined sequences match first
    a.sort(function (a, b) {
        return b.length - a.length;
    });
    // Escape code points, they get corrupted by uglify otherwise
    emoji.rx_unified = new RegExp('('+a.join('|')+')(\\uD83C[\\uDFFB-\\uDFFF])?([^\\ufe0e]|$)');
};
emoji.init_env = function(){
    if (emoji.inits.env) return;
    emoji.inits.env = 1;
    emoji.replace_mode = 'img';
    emoji.supports_css = false;
    if (window.getComputedStyle){
        var st = window.getComputedStyle(document.body);
        if (st['background-size'] || st['backgroundSize']){
            emoji.supports_css = true;
        }
    }
    if (emoji.supports_css) {
        emoji.replace_mode = 'css';
    }
    if (emoji.is_mac_os_native() || emoji.is_windows_native() || emoji.is_cr_os_native()) {
        emoji.replace_mode = 'unified';
    }
};

var _is_cr_os_native = null;
emoji.is_cr_os_native = function () {
    if (_is_cr_os_native === null) {
        _is_cr_os_native = emoji.re.ua_cr_os.test(navigator.userAgent);
    }
    return _is_cr_os_native;
};

var _is_windows_native = null;
emoji.is_windows_native = function () {
    if (_is_windows_native === null) {
        _is_windows_native = emoji.re.ua_windows_os.test(navigator.userAgent);
    }
    return _is_windows_native;
};

var _is_mac_os_native = null;
emoji.is_mac_os_native = function () {
    if (_is_mac_os_native === null) {
        _is_mac_os_native = emoji.re.ua_mac_os.test(navigator.userAgent);
    }
    return _is_mac_os_native;
};



//////////////////
// WEBPACK FOOTER
// ./app/src/lib/emoji.js
// module id = xpYO
// module chunks = 1